import React from 'react';
import { StyleSheet, Text, View } from './base_components';
import { withRouter } from 'inferno-router';

import ProgressSpinner from './progress_spinner';
import TextButton from './buttons/text_button';

import UserAdminStore from '../stores/user_admin_store';

const styles = StyleSheet.create({
  decoderList: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  noText: {
    paddingTop: '1em',
    paddingBottom: '1em',
    color: '#666',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  headerRow: {
    marginBottom: '1em',
    paddingBottom: '0.3em',
    borderBottomWidth: '1px',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  userRow: {
    padding: '0.5em',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue',
    },
  },
  userName: {
    width: '15em',
    color: '#666',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  userEmail: {
    width: '30em',
    color: '#666',
    fontSize: '1.2em',
  },
  actionButton: {
    marginRight: '0.4em',
    height: '2.0em',
  },
  headerText: {
    color: '#333',
    fontWeight: '800',
  },
  actionText: {
    width: '20em',
    color: '#666',
    fontSize: '1.2em',
    fontWeight: '500',
  },
});

type Props = {
  style?: any;
  history: any;
  onDelete: (user_id: string) => void;
};
type State = {
  user_list: any;
};

class UserList extends React.PureComponent<Props, State> {
  state = {
    user_list: null,
  };
  componentDidMount() {
    UserAdminStore.addChangeListener(this._onUserUpdate);
    UserAdminStore.fetch();
    this._onUserUpdate();
  }
  componentWillUnmount() {
    UserAdminStore.removeChangeListener(this._onUserUpdate);
  }
  _onUserUpdate = () => {
    const user_list = UserAdminStore.getList();
    this.setState({ user_list });
  };
  _onManage = (user_id) => {
    this.props.history.push('/admin/user/' + user_id);
  };

  render() {
    const { style, onDelete } = this.props;
    const { user_list } = this.state;

    let inner = null;
    if (user_list === null) {
      inner = <ProgressSpinner />;
    } else if (user_list.length === 0) {
      inner = <Text style={styles.noText}>No Users added yet</Text>;
    } else {
      inner = user_list.map((u) => (
        <UserRow
          key={u.user_id}
          user={u}
          onManage={this._onManage}
          onDelete={onDelete}
        />
      ));
    }

    return (
      <View style={[styles.decoderList, style]}>
        <View style={styles.headerRow}>
          <Text style={[styles.userName, styles.headerText]}>User Name</Text>
          <Text style={[styles.userEmail, styles.headerText]}>Email</Text>
          <Text style={[styles.actionText, styles.headerText]}>Actions</Text>
        </View>
        {inner}
      </View>
    );
  }
}
export default withRouter(UserList);

function UserRow(props) {
  const { user, onManage, onDelete } = props;
  const { user_id, user_name, email } = user;

  function _onManage() {
    onManage(user_id);
  }
  function _onDelete() {
    onDelete(user_id);
  }

  return (
    <View style={styles.userRow}>
      <Text style={styles.userName}>{user_name}</Text>
      <Text style={styles.userEmail}>{email}</Text>
      <TextButton
        style={styles.actionButton}
        text='Manage'
        onPress={_onManage}
      />
      <TextButton
        style={styles.actionButton}
        text='Delete'
        onPress={_onDelete}
      />
    </View>
  );
}
